import { Pipe, PipeTransform } from '@angular/core';
import { LocaleService } from '../../services/locale/locale.service';
import { formatNumber } from '@angular/common';

@Pipe({
    name: 'localNumber',
})
export class LocalNumberPipe implements PipeTransform {
    public constructor(private readonly localeService: LocaleService) {}

    public transform(value: number, format = '.2-2'): unknown {
        if (!value) {
            return '';
        }
        return formatNumber(value, this.localeService.locale, format);
    }
}
